import 'slick-carousel-latest';
export default (($) => {
    const $dom = {};
    const options = {};
    const Slider = function () { };
    const cacheDom = () => {
        $dom.defaultSlider = $('.js-default-slider');
        $dom.ambassadorSlider = $('.js-ambassador-slider');
    };
    const sliderConstructor = () => {
        console.log('UNTUCKit : Module : Sliders : sliderConstructor');
        const next = `<span class="slick-arrow next"><span class="icon-arrow right black big"></span></span>`;
        const prev = `<span class="slick-arrow prev"><span class="icon-arrow left black big"></span></span>`;
        Slider.prototype.init = function (slidesToShow = 1, slidesToScroll = 1, arrows = true, dots = false, infinite = true, variableWidth = false, mobileFirst = true, draggable = true, responsive = [], nextArrow = next, prevArrow = prev, appendArrows) {
            this.slidesToShow = slidesToShow;
            this.slidesToScroll = slidesToScroll;
            this.arrows = arrows;
            this.dots = dots;
            this.infinite = infinite;
            this.variableWidth = variableWidth;
            this.mobileFirst = mobileFirst;
            this.draggable = draggable;
            this.responsive = responsive;
            this.nextArrow = nextArrow;
            this.prevArrow = prevArrow;
            this.appendArrows = appendArrows;
        };
    };
    const buildSliders = () => {
        console.log('UNTUCKit : Module : Sliders : buildSliders');
        // Default Slider
        const defaultSlider = new Slider();
        defaultSlider.init();
        options.defaultSlider = defaultSlider;
        // Ambassador Slider
        const responsiveOptions = [
            {
                breakpoint: 768,
                settings: {
                    draggable: false,
                    infinit: false,
                    variableWidth: true,
                },
            },
        ];
        const ambassadorSlider = new Slider();
        ambassadorSlider.init(1, 1, false, false, true, false, true, true, responsiveOptions);
        ambassadorSlider.appendArrows = $('.ambassadors__slide-headline');
        options.ambassadorSlider = ambassadorSlider;
        // Return options obj
        return options;
    };
    const initSliders = () => {
        console.log('UNTUCKit : Module : Sliders : initSliders');
        $dom.defaultSlider.slick(buildSliders().defaultSlider);
        $dom.ambassadorSlider.slick(buildSliders().ambassadorSlider);
    };
    const init = () => {
        console.log('UNTUCKit : Module : Sliders : init');
        cacheDom();
        sliderConstructor();
        initSliders();
    };
    return { init };
})($);
